import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';

import ArrowLeft from '@mui/icons-material/ArrowBack';
import ArrowRight from '@mui/icons-material/ArrowForward';

import Button from '../Button';

const getPages = (current, total) => {
  const pages = [];

  const window = 1; // pages on each side of current

  // Always show first page
  pages.push(1);

  // Left ellipsis
  if (current - window > 2) {
    pages.push('…');
  }

  // Middle window
  for (
    let i = Math.max(2, current - window);
    i <= Math.min(total - 1, current + window);
    i++
  ) {
    pages.push(i);
  }

  // Right ellipsis
  if (current + window < total - 1) {
    pages.push('…');
  }

  // Always show last page
  if (total > 1) {
    pages.push(total);
  }

  return pages;
};

const TablePagination = (props) => {
  const {
    page,
    totalPages,
    onPageChange,
    // rowsPerPage,
    // rowsPerPageOptions = [10, 20, 50, 100],
    // onRowsPerPageChange,
  } = props;

  const pages = getPages(page, totalPages);

  return (
    <Box
      sx={{ m: 2 }}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Button
        type="secondary"
        variant="outlined"
        startIcon={<ArrowLeft color="secondary" />}
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        text="Previous"
      />

      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box display="flex" alignItems="center" gap={1}>
          {pages.map((p, idx) =>
            p === '…' ? (
              <Typography
                key={`ellipsis-${page}-${idx}`}
                color="text.secondary"
              >
                …
              </Typography>
            ) : (
              <IconButton
                key={`page-${p}`}
                onClick={() => onPageChange(p)}
                sx={(theme) => ({
                  width: 36,
                  height: 36,
                  borderRadius: '12px',
                  fontSize: '16px',
                  color: theme.palette.text.primary,
                  backgroundColor: p === page
                    ? (theme.palette.mode === 'dark' ? 'var(--color-hover-surface)' : '#f2f4f7')
                    : 'transparent',
                  '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' ? 'var(--color-hover-surface)' : '#f2f4f7',
                  },
                })}
              >
                {p}
              </IconButton>
            )
          )}
        </Box>
      </Box>

      <Button
        type="secondary"
        endIcon={<ArrowRight color="secondary" />}
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
        text="Next"
      />
    </Box>
  );
};

export default TablePagination;
